/*
 * Copyright (c) 2024 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */
import Cookies from "js-cookie";

import { resetAnalytics } from "common/analytics";
import {
    ACCESS_TOKEN,
    COGNITO_CLIENT_ID,
    DRIVER_SESSION,
    ID_TOKEN,
    REFRESH_TOKEN,
} from "pages/LoginWeb/constants";

interface SetCookieParams {
    name: string;
    value: string;
    expirationInDays?: number;
}

export const setCookie = ({ name, value, expirationInDays = 7 }: SetCookieParams) => {
    Cookies.set(name, value, { expires: expirationInDays });
};

export const setCookies = ({ accessToken, idToken, refreshToken }) => {
    accessToken && Cookies.set(ACCESS_TOKEN, accessToken);
    idToken && Cookies.set(ID_TOKEN, idToken);
    refreshToken && Cookies.set(REFRESH_TOKEN, refreshToken);
};

export const removeCookies = () => {
    [ACCESS_TOKEN, ID_TOKEN, REFRESH_TOKEN, DRIVER_SESSION, COGNITO_CLIENT_ID].forEach(
        (cookie) => Cookies.remove(cookie)
    );

    // Clear the Mixpanel identity so a shared browser doesn't attribute the next
    // driver's events to the previous one. Centralized here because it is the single
    // chokepoint every session-ending path (logout, refresh failure, unsupported city) funnels through.
    resetAnalytics();
};
